export enum ErrorToastMessagesE {
    SOMETHING_WENT_WRONG = 'Something went wrong',
    INVALID_LOGIN_OR_PASSWORD = 'Invalid login or password',
    EMAIL_OR_PASSWORD_IS_INCORRECT = 'Either email or password is incorrect',
    YOU_ARE_ALREADY_LOGGED_IN = 'You are already logged in',
}

export enum SuccessToastMessagesE {
    SUCCESSFULLY_LOGGED = 'Successfully logged',
}